import { useHomeIQ } from "@/homeiq/state/HomeIQContext";

const CONTENT = {
    disclaimer: {
        title: "Disclaimer",
        body: "HomeIQ provides indicative estimates based on user inputs and publicly available data. All numbers are for educational purposes only and do not constitute financial, legal, or investment advice. Please consult a qualified advisor before making any decision.",
    },
    terms: {
        title: "Terms of Use",
        body: "By using HomeIQ you agree to our terms of fair use. The platform is provided as-is, without warranties of any kind. HomeIQ is not liable for any decisions made on the basis of information presented in the application.",
    },
    privacy: {
        title: "Privacy Policy",
        body: "HomeIQ stores only the inputs you provide. We do not sell personal data. Uploaded floor plans are processed in-session and discarded after analysis. See our full policy for retention and rights.",
    },
};

export default function LegalModal() {
    const { legalModal, setLegalModal } = useHomeIQ();
    if (!legalModal) return null;
    const { title, body } = CONTENT[legalModal];
    return (
        <div
            data-testid="legal-modal"
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
            <div
                onClick={() => setLegalModal(null)}
                data-testid="legal-modal-backdrop"
                className="absolute inset-0 bg-[#0A1F44]/40 backdrop-blur-sm"
            />
            <div className="relative bg-white rounded-3xl border border-[#0A1F44]/10 shadow-[0_30px_80px_-30px_rgba(10,31,68,0.4)] max-w-lg w-full p-6 md:p-8">
                <div className="flex items-start justify-between mb-4">
                    <h3 className="font-display font-extrabold text-2xl text-[#0A1F44]">
                        {title}
                    </h3>
                    <button
                        type="button"
                        onClick={() => setLegalModal(null)}
                        data-testid="legal-modal-close"
                        className="text-[#0A1F44]/50 hover:text-[#0A1F44] text-xl leading-none"
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                <p className="text-sm text-[#0A1F44]/70 leading-relaxed">{body}</p>
            </div>
        </div>
    );
}
